import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import _ from 'lodash';
import I18N from './I18N';

class EBModal extends React.PureComponent {
  render() {
    const {
      isOpen,
      className,
      children,
      type,
      title,
      content,
      btnConfirmText,
      btnCancelText,
      onConfirm,
      toggleModal,
      showHeader,
      showFooter,
      ebTestCancelValue,
      ebTestConfirmValue,
      ebTestOkValue,
      backdrop,
      centered,
    } = this.props;

    const modalTitle = _.isArray(title) ? title.join(',') : title;
    const modalContent = _.isArray(content) ? content.join(',') : content;
    const modalBtnConfirm = _.isArray(btnConfirmText) ? btnConfirmText.join(',') : btnConfirmText;
    return (
      <Modal
        aria-labelledby="modalTitle"
        isOpen={isOpen}
        toggle={toggleModal}
        className={`${className} eb-modal`}
        backdrop={backdrop}
        centered={centered}
      >
        {
          showHeader && (
            <ModalHeader toggle={toggleModal} id="modalTitle">
              <I18N>
                {modalTitle
                  || (
                    type === 'confirm'
                      ? 'global.dialog.title.confirm'
                      : 'global.dialog.title.alert'
                  )
                }
              </I18N>
            </ModalHeader>
          )
        }

        <ModalBody id="modalContent">
          <I18N>{modalContent}</I18N>
          {children}
          {!content && !children && type === 'confirm' && <I18N>entity.delete.confirm</I18N>}
        </ModalBody>
        {showFooter && (
          <ModalFooter>
            {type === 'confirm' && (
              <Fragment>
                <Button color="secondary" onClick={toggleModal} eb-test={ebTestCancelValue}>
                  <I18N>{btnCancelText}</I18N>
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    toggleModal();
                    if (onConfirm) {
                      onConfirm();
                    }
                  }}
                  eb-test={ebTestConfirmValue}
                >
                  <I18N>{modalBtnConfirm}</I18N>
                </Button>
              </Fragment>
            )}
            {type === 'warn' && (
              <Button color="primary" onClick={toggleModal} eb-test={ebTestOkValue}>
                <I18N>global.dialog.button.ok</I18N>
              </Button>
            )}
          </ModalFooter>
        )}

      </Modal>
    );
  }
}
EBModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  btnConfirmText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  btnCancelText: PropTypes.string,
  onConfirm: PropTypes.func,
  children: PropTypes.element,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  ebTestCancelValue: PropTypes.string,
  ebTestConfirmValue: PropTypes.string,
  ebTestOkValue: PropTypes.string,
  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  centered: PropTypes.bool
};

EBModal.defaultProps = {
  className: 'small-modal',
  type: 'confirm',
  title: '',
  children: null,
  content: '',
  btnConfirmText: 'global.dialog.button.ok',
  btnCancelText: 'global.dialog.button.cancel',
  showHeader: true,
  showFooter: true,
  onConfirm: () => {},
  ebTestCancelValue: 'modal_cancel_button',
  ebTestConfirmValue: 'modal_confirm_button',
  ebTestOkValue: 'modal_ok_button',
  backdrop: true,
  centered: false,
};

export default EBModal;
